import React, { useState, useRef } from "react";
import logo from "../../logo.png";
import styles from "./AutoplayGate.module.scss";

const GATE_KEY = "4play_autoplay_unlocked";

const AutoplayGate = ({ children }) => {
  const [unlocked, setUnlocked] = useState(() => {
    return sessionStorage.getItem(GATE_KEY) === "1";
  });
  const tapped = useRef(false);

  const unlock = () => {
    if (tapped.current) return;
    tapped.current = true;

    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const buf = ctx.createBuffer(1, 1, 22050);
      const src = ctx.createBufferSource();
      src.buffer = buf;
      src.connect(ctx.destination);
      src.start(0);
      ctx.resume().catch(() => {});
    } catch (_) {}

    sessionStorage.setItem(GATE_KEY, "1");
    setUnlocked(true);
  };

  if (unlocked) return children;

  return (
    <div
      className={styles.gate}
      onClick={unlock}
      onTouchEnd={(e) => { e.preventDefault(); unlock(); }}
    >
      <img src={logo} alt="4Play" className={styles.logo} />
      <p className={styles.text}>Tap to start</p>
    </div>
  );
};

export default AutoplayGate;
